document.addEventListener('DOMContentLoaded', function () {
  const menuButton = document.querySelector('.menu-btn');
  const mainNav = document.querySelector('.main-nav');
  if (menuButton && mainNav) {
    menuButton.addEventListener('click', function () {
      const isOpen = mainNav.classList.toggle('open');
      menuButton.setAttribute('aria-expanded', String(isOpen));
    });
  }

  const dropdowns = Array.from(document.querySelectorAll('.fr-main-nav details'));
  dropdowns.forEach(function (details) {
    details.addEventListener('toggle', function () {
      if (!details.open) return;
      dropdowns.forEach(function (other) {
        if (other !== details) other.removeAttribute('open');
      });
    });

    if (window.matchMedia('(min-width: 901px)').matches) {
      let closeTimer;
      details.addEventListener('mouseenter', function () {
        clearTimeout(closeTimer);
        details.setAttribute('open', '');
      });
      details.addEventListener('mouseleave', function () {
        closeTimer = setTimeout(function () { details.removeAttribute('open'); }, 120);
      });
    }
  });

  document.addEventListener('click', function (event) {
    dropdowns.forEach(function (details) {
      if (!details.contains(event.target)) details.removeAttribute('open');
    });
  });
});
